import { useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext } from 'commons-ui';

import useService from './useService';
import { APPROVE_REJECT_KYC_STATUS } from './constants';

export interface IUseHandlerProps {
	handleForceUpdate?: () => void;
	kycId?: any;
}

const useHandler = (props: IUseHandlerProps) => {
	const { handleForceUpdate = _noop, kycId } = props;
	const { updateKYCStatus } = useService();
	const { setModalConfig } = useContext(ModalContext);

	const onAgreeApproveKyc = async () => {
		await updateKYCStatus({
			message: '',
			kycId,
			status: APPROVE_REJECT_KYC_STATUS.APPROVED
		});
		handleForceUpdate();
		setModalConfig({ isOpen: false });
	};
	const onDisAgreeApproveKyc = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		onAgreeApproveKyc,
		onDisAgreeApproveKyc
	};
};

export default useHandler;
